module.exports = __webpack_public_path__ + "img/bank_auth.3601aaab.svg";